import script from "./FormUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./FormUpload.vue?vue&type=script&setup=true&lang=js"

import "./FormUpload.vue?vue&type=style&index=0&id=0795e4c8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0795e4c8"]])

export default __exports__